export default __webpack_public_path__ + "static/media/taco-dish.416c876b.jpg";